var React = require('react');

function Monetization (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.537 18.9383H34.15C35.5455 18.9383 36.6863 20.0808 36.6863 21.4749V24.5864H3V21.4749C3 20.0808 4.1424 18.9383 5.537 18.9383ZM19.8434 0L27.4143 9.29435H23.8012V15.8039H15.8847V9.29435H12.2716L19.8434 0ZM36.686 27.0547V37.4633C36.686 38.8597 35.5457 40 34.1497 40H5.53666C4.14161 40 3 38.8597 3 37.4633V27.0547H36.686Z"}));
}

Monetization.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = Monetization;

Monetization.default = Monetization;
